
import request from '@/utils/request' // 引入请求模块
// // 登录
// export function login(data) {
//   return request({
//     url: "/user/loginByMobile",
//     method: "post",
//     data: data
//   });
// }
// 通告详情
export function getArticleList (data) {
  return request({
    url: '/nodeCenter/getArticleList',
    method: 'get',
    params: data,
  })
}

// 城市天气获取
export function getLocationWeather (data) {
  return request({
    url: '/nodeCenter/getLocationWeather',
    method: 'get',
    params: data,
  })
}

//获取站长卡片信息
export function getNodeManagerCard (data) {
  return request({
    url: '/nodeCenter/getNodeManagerCard',
    method: 'get',
    params: data,
  })
}

//完善站长信息
export function perfectUserInfo (data) {
  return request({
    url: '/nodeCenter/perfectUserInfo',
    method: 'post',
    data: data,
  })
}

//获取寄语详情
export function getSloganList (data) {
  return request({
    url: '/nodeCenter/getSloganList',
    method: 'get',
    params: data,
  })
}

//上传图片
export function uploadImage (data) {
  return request({
    url: '/common/system/uploadImage',
    method: 'post',
    data,
    headers:{'Content-Type':'multipart/form-data'}
  })
}

//省市区
export function getRegionalList (params) {
  return request({
    url: '/common/system/getThereRegionalInformation',
    method: 'get',
    params
  })
}


//获取分类列表
export function getCategoryList (params) {
  return request({
    url: '/nodeCenter/getCategoryList',
    method: 'get',
    params
  })
}

//文章列表带分类
export function getArticleListByCate (params) {
  return request({
    url: '/nodeCenter/getArticleListByCate',
    method: 'get',
    params
  })
}

//文章详情
//文章列表带分类
export function getArticleDetails (params) {
  return request({
    url: '/nodeCenter/getArticleDetails',
    method: 'get',
    params
  })
}



// 操作记录新增
export function createOperateWithArticle(data,id) {
  return request({
    url: `/nodeCenter/createOperateWithArticle?articleId=${id}`,
    method: "post",
    data
  });
}
